export default
`<template>
  <DtMemberStack
    :members="members"
    vertical
  />

  <DtMemberStack
    :members="members"
  />
</template>`;